import { BreadcrumbTemplateEnum, Breadcrumbs, Page, PageHeader, PageInner, PageSection } from "@app/shared";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { TileProps } from "@app/shared/interfaces/dashboard";
import * as React from "react";
import { Link } from "react-router-dom";
import { FeatureFlagContext, Features } from "../feature-flags";

function getTiles(featureFlags: Set<string>): TileProps[] {
  return [
    {
      icon: QesIcons.FontAwesome.Cogs,
      route: "jobs",
      title: "Jobs",
    },
    {
      icon: QesIcons.FontAwesome.Map,
      route: "jobqueuemap",
      title: "Job Queue Map"
    },
    ...featureFlags.has(Features.OPERATIONS_JOB_QUEUES_PAGE) ?
      [{
        icon: QesIcons.FontAwesome.ObjectGroup,
        route: "jobqueues",
        title: "Job Queues"
      }] : [],
    {
      icon: QesIcons.FontAwesome.LineChart,
      route: "weekendrunmonitoring",
      title: "Weekend Run Monitoring",
    }
  ]
};

export const OperationsDashboard: React.FC<React.PropsWithChildren<unknown>> = () => {
  const featureFlags = React.useContext(FeatureFlagContext).enabledFeatureFlags;

  return (
    <Page documentTitle="Operations Dashboard">
      <Breadcrumbs template={BreadcrumbTemplateEnum.Operations} items={["Dashboard"]} />
      <PageInner>
        <PageHeader iconName={QesIcons.FontAwesome.Cogs} title="Operations Dashboard" disableHR={false} />
        <PageSection>
          <div className="container mt-3">
            {getTiles(featureFlags).map((tile) => <Tile key={tile.title} icon={tile.icon} route={tile.route} title={tile.title} isV1={tile.isV1} />)}
          </div>
        </PageSection>
      </PageInner>
    </Page>
  );
};

const Tile: React.FC<React.PropsWithChildren<TileProps>> = ({ icon, route = "#", title, isV1 }) => {
  if (isV1) {
    return (
      <a href={`${window.uiEndpoint}/${route}`} className="dashboard-tile col-4">
        <QesIcon iconName={icon} width="26" height="26" isDecorative={true} />
        <h6>{title}</h6>
      </a>
    );
  } else {
    return (
      <Link to={route} className="dashboard-tile col-4">
        <QesIcon iconName={icon} width="26" height="26" isDecorative={true} />
        <h6>{title}</h6>
      </Link>
    );
  }
};
